module.exports = __webpack_public_path__ + "img/img_residencial3.5af96d32.png";